import React from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage } from 'react-intl';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import translations from './translations';

const ItemQuantity = ({ quantity }) => (
  <Box px={2} pb={2}>
    <Typography variant="overline" color="textSecondary">
      <FormattedHTMLMessage {...translations.properties.quantity} />
    </Typography>
    <Typography variant="body2" color="textPrimary">
      {quantity}
    </Typography>
  </Box>
);

ItemQuantity.propTypes = {
  quantity: PropTypes.number,
};

ItemQuantity.defaultProps = {
  quantity: 0,
};

export default ItemQuantity;
